import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'limit' })
export class LimitPipe implements PipeTransform {
    transform(value: any[], limit: number): any[] {
        if (!limit || (value instanceof Array) === false) return value;

        return value.filter((obj, index) => index < limit);
    }
}
